import React from 'react';
import './style.scss';

const Footer = () => (
	<footer className="footer center has-background-light">
		<div className="content has-text-centered">
			<p className="is-size-5">
			All rights reserved (c) 2019 ProcWorks
			</p>
		</div>
	</footer>
);

export default Footer;
